export let LayeredNavigationType;
(function (LayeredNavigationType) {
  LayeredNavigationType["Dropdown"] = "dropdown";
  LayeredNavigationType["Number"] = "numberField";
  LayeredNavigationType["MultiSelect"] = "multipleSelect";
})(LayeredNavigationType || (LayeredNavigationType = {}));